import { customAdjustmentTypeApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const CUSTOM_ADJUSTMENTS_ACTION_TYPE = createNamedActions('customAdjustments', {
  GET_CUSTOM_ADJUSTMENTS: 'GET_CUSTOM_ADJUSTMENTS',
  CREATE_CUSTOM_ADJUSTMENT: 'CREATE_CUSTOM_ADJUSTMENT',
  EDIT_CUSTOM_ADJUSTMENT: 'EDIT_CUSTOM_ADJUSTMENT',
  DELETE_CUSTOM_ADJUSTMENT: 'DELETE_CUSTOM_ADJUSTMENT',
  ENABLE_CUSTOM_ADJUSTMENT: 'ENABLE_CUSTOM_ADJUSTMENT',
});

const customAdjustmentsSchema = new schema.Entity(
  'data',
  {},
  { idAttribute: 'customAdjustmentTypeId' },
);

export const getCustomAdjustmentsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customAdjustmentTypeApi.getCustomAdjustmentType(params);

  return dispatch({
    type: CUSTOM_ADJUSTMENTS_ACTION_TYPE.GET_CUSTOM_ADJUSTMENTS,
    payload: normalize(data, [customAdjustmentsSchema]).entities.data,
  });
});

export const createCustomAdjustmentAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customAdjustmentTypeApi.createCustomAdjustmentType(params);

  return dispatch({
    type: CUSTOM_ADJUSTMENTS_ACTION_TYPE.CREATE_CUSTOM_ADJUSTMENT,
    payload: data,
  });
});

export const editCustomAdjustmentAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customAdjustmentTypeApi.editCustomAdjustmentType(params);

  return dispatch({
    type: CUSTOM_ADJUSTMENTS_ACTION_TYPE.EDIT_CUSTOM_ADJUSTMENT,
    payload: data,
  });
});

export const deleteCustomAdjustmentAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customAdjustmentTypeApi.deleteCustomAdjustmentType(params);

  return dispatch({
    type: CUSTOM_ADJUSTMENTS_ACTION_TYPE.DELETE_CUSTOM_ADJUSTMENT,
    payload: data,
    meta: params,
  });
});

export const enableCustomAdjustmentAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await customAdjustmentTypeApi.activateCustomAdjustmentType(params);

  return dispatch({
    type: CUSTOM_ADJUSTMENTS_ACTION_TYPE.ENABLE_CUSTOM_ADJUSTMENT,
    payload: data,
    meta: params,
  });
});
